import { request } from './http.js'

/** 指数清单（含最新点位/涨跌幅/覆盖区间） */
export async function fetchIndexList() {
  const data = await request('/api/index/list')
  return data.list || []
}

/** 指数区间日线：codes 数组 + start/end（YYYY-MM-DD，可省略） */
export async function fetchIndexTrend({ codes, start, end }) {
  const params = new URLSearchParams()
  const list = Array.isArray(codes) ? codes : [codes]
  params.set('codes', list.filter(Boolean).join(','))
  if (start) params.set('start', start)
  if (end) params.set('end', end)
  return request(`/api/index/daily?${params.toString()}`)
}
